import styled from 'styled-components';
import { Container, Row } from 'reactstrap';
import { lighterGrey } from '../../styles/styled/colors';

export const Wrapper = styled(Container)`
    background: ${lighterGrey};
    min-height: 130px;
    min-width: 960px;
`

export const BtnWrapperInline = styled.div`
    left: -5px;
    position: relative;
    padding-top: 12px;
`

export const BtnWrapper = styled(Row)`
    left: -5px;
    position: relative;
`



// WEBPACK FOOTER //
// ./src/components/AddNode/Styled.js